/**
 * @file Contains the hook to check if the compose form has been updated
 */
import { useRef } from 'react';

import { MessageStatus } from '../../../../generated/graphql';
import { ComposeUpdates } from '../types';

/**
 * Hook to check if the compose form has been updated
 *
 * @param checklist Array of checklist items
 * @param labels    Array of labels
 * @param status    Message status
 *
 * @returns         Object with boolean values indicating if the compose form has been updated
 */
const useComposeUpdates = (
  checklist: string[],
  labels: string[],
  status: MessageStatus | null,
): Record<ComposeUpdates, boolean> => {
  const currentState = useRef({
    checklist,
    labels,
    status: status ?? MessageStatus.OPEN,
  });

  return {
    attach: false,
    checklist:
      JSON.stringify(currentState.current.checklist) !==
      JSON.stringify(checklist),
    label:
      JSON.stringify(currentState.current.labels) !== JSON.stringify(labels),
    status: currentState.current.status !== status,
  };
};

export default useComposeUpdates;
